import React from 'react';
import { IconBase } from '../Base';
export const IconCopy = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M7.75 12.75H4.75C3.64543 12.75 2.75 11.8546 2.75 10.75V4.75C2.75 3.64543 3.64543 2.75 4.75 2.75H10.75C11.8546 2.75 12.75 3.64543 12.75 4.75V7.75", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinejoin: "round" }),
        React.createElement("rect", { x: "7.25", y: "7.25", width: "10", height: "10", rx: "2", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Copy.js.map